export interface IntervalCounterSample {
  sampledAtMs: number;
  elapsedMs: number;
  current?: number;
  delta?: number;
  resetDetected: boolean;
}

export function intervalCounterSample(
  current: number | undefined,
  previous: number | undefined,
  sampledAtMs: number,
  previousAtMs: number | undefined,
): IntervalCounterSample {
  const elapsedMs = previousAtMs === undefined ? 0 : Math.max(0, sampledAtMs - previousAtMs);
  if (current === undefined || !Number.isFinite(current)) {
    return { sampledAtMs, elapsedMs, resetDetected: false };
  }
  if (previous === undefined || !Number.isFinite(previous) || previousAtMs === undefined) {
    return { sampledAtMs, elapsedMs, current, resetDetected: false };
  }
  if (elapsedMs <= 0 || current < previous) {
    return { sampledAtMs, elapsedMs, current, resetDetected: true };
  }
  return { sampledAtMs, elapsedMs, current, delta: current - previous, resetDetected: false };
}

export class CounterDeltaTracker {
  private previous?: { value: number; sampledAtMs: number };

  sample(current: number | undefined, sampledAtMs: number): IntervalCounterSample {
    const result = intervalCounterSample(current, this.previous?.value, sampledAtMs, this.previous?.sampledAtMs);
    if (current !== undefined && Number.isFinite(current)) this.previous = { value: current, sampledAtMs };
    return result;
  }

  reset(): void {
    this.previous = undefined;
  }
}
